import React from 'react';
interface VideoTypeSelectorProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
}
export const VideoTypeSelector: React.FC<VideoTypeSelectorProps> = ({
  value,
  onChange,
  className = ''
}) => {
  const videoTypes = [{
    id: 'motivational',
    label: 'Motivational'
  }, {
    id: 'business',
    label: 'Business'
  }, {
    id: 'educational',
    label: 'Educational'
  }, {
    id: 'creative',
    label: 'Creative'
  }, {
    id: 'lifestyle',
    label: 'Lifestyle'
  }, {
    id: 'other',
    label: 'Other'
  }];
  return <div className={`space-y-3 ${className}`} data-id="element-2953">
      <label className="block text-sm font-medium text-gray-700 dark:text-[#C4D1CC]" data-id="element-2954">
        Video Type
      </label>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3" data-id="element-2955">
        {videoTypes.map(type => <button key={type.id} type="button" className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${value === type.id ? 'bg-[#2DB489] dark:bg-[#4ED1A0] text-white' : 'bg-gray-100 dark:bg-[#1A3330] text-gray-700 dark:text-[#B0C1BD] hover:bg-gray-200 dark:hover:bg-[#0B2C2A]'}`} onClick={() => onChange(type.id)} data-id="element-2956">
            {type.label}
          </button>)}
      </div>
    </div>;
};